import { Box, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FC, useState } from "react";
import { RequestEnviarPagamento } from "../acoes/enviarPagamento/types";
import { IDataRequest, apiNoLoading } from "src/framework/providers/api";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { Projeto } from "../types";

export interface EnviarPagamentoButtonProperties {    
    codigoVenda: string | any;
    notaTriangular: boolean | any;
    tipoProposta: string | any;
    idProjeto: number | any;
    onFinish: (url: any)=>void;
}
const useStyles = makeStyles({
    buttonText: {
        fontSize: "14px",
        cursor: "pointer",
        textDecoration: "underline",
        color: "#0F0FEF",
        background: 'none',
        lineHeight: 1.5,
        border: 0,
        padding: 0,
      },
    spinner: {
        border: "2px solid rgba(0, 0, 0, 0.1)",
        borderTop: "2px solid #5D5B5B",
        borderRadius: "50%",
        width: "18px",
        height: "18px",
        animation: "spin 1s linear infinite",
        marginLeft: "5px"
    }
  })

const RELOADING_PARAMS = {
    timeout: 3000, //timeout entre enviar uma nova requisicao de consulta
    times: 3 // numero maximo de tentativas
}

const EnviarPagamentoButton: FC<EnviarPagamentoButtonProperties> = ({
    codigoVenda,
    notaTriangular,
    tipoProposta,
    idProjeto,
    onFinish
}) => {
    const permissoes = PermissionUtil.getPermissions();
    const [loading, setLoading] = useState(false)
    const [resent, setResent] = useState(false)
    const classes = useStyles();

    function sleep(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const handleSearchProjeto = async () => {
        if (!idProjeto) return;

        for (let i = 0; i < RELOADING_PARAMS.times; i++) {
            try {
                const findProjeto: IDataRequest = {
                    url: `/projetos/consultar/detalhe/${idProjeto}`,
                };

                const resp: any = await apiNoLoading.get(findProjeto);
                const urlPagamento = resp.data?.[0]?.url_pagamento;

                if (urlPagamento) {
                    onFinish(urlPagamento);
                    return;
                }
            } catch (error: any) {
                console.error(`Erro ao consultar detalhes do Projeto ${idProjeto}`, JSON.stringify({ error }));
            }

            await sleep(RELOADING_PARAMS.timeout);
        }
    };

    const handleEnviarPagamento = async () => {
        if (loading) return;

        if (resent) {
            handleSearchProjeto();
            return;
        }

        let reenviar = true;
        let projeto: Projeto | any = null;
        if(idProjeto){
            const findProjeto: IDataRequest = {
                url: `/projetos/consultar/detalhe/${idProjeto}`
            }
            await apiNoLoading.get(findProjeto).then((resp: any)=>{
                projeto = resp.data[0];
                if(projeto?.url_pagamento){
                    //caso já tenha url nao reenvia
                    reenviar = false
                    onFinish(projeto?.url_pagamento);
                }
            }).catch((error: any) => {
                console.error(`Erro ao buscar Projeto ${idProjeto}`, JSON.stringify({ error }));
            })
        }
        if(reenviar){
            const dataRequest: RequestEnviarPagamento = {
                codigo_venda: codigoVenda,
                nota_fiscal_triangular: notaTriangular,
                tipo_proposta_envio: tipoProposta,
            }
            const request: IDataRequest = {
                url: "/projetos/reprocessar_pagamento",
                data: dataRequest
            }
            
            await apiNoLoading.post(request).then((resp)=>{
                setResent(true)
                handleSearchProjeto();
            }).catch((error)=>{
                console.error(`Erro ao reenviar Projeto ${codigoVenda} para Pagamento`, JSON.stringify({ error }));
            })
        }
    }

    return (
        <Box style={{padding: "0px"}}>
            <Typography
                style={{fontSize: "14px", fontFamily: "inherit", padding:"0px"}}
            >
                Falha ao gerar o link de pagamento.
            </Typography>
            {PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_REPROCESSAR_PAGAMENTO, permissoes) && (<Typography>
                <Box style={{display: "flex"}}>
                    <button 
                        disabled={loading}
                        className={classes.buttonText} 
                        onClick={async () => {
                            setLoading(true);
                            try {
                                await handleEnviarPagamento();
                            } catch (error) {
                                console.error(error);
                            } finally {
                               setTimeout(() =>  setLoading(false), 500);
                            }
                        }} 
                    >
                        Clique aqui para reenviar.
                    </button>
                    {loading &&(<div className={classes.spinner}></div>)}
                </Box>
            </Typography>)}
        </Box>
    )
}

export default EnviarPagamentoButton;